import { render, staticRenderFns } from "./VideosWidgetItem.vue?vue&type=template&id=0c4dcc08&"
import script from "./VideosWidgetItem.vue?vue&type=script&lang=js&"
export * from "./VideosWidgetItem.vue?vue&type=script&lang=js&"
import style0 from "./VideosWidgetItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports